export default __webpack_public_path__ + "static/media/March2013.a41d0ae4.png";